
import Immutable from 'immutable';
import {ReduceStore} from 'flux/utils';

import {OrderAction, UserAction} from 'AppAction';

import Dispatcher from 'service/Dispatcher';

const DiscountCoupon = new Immutable.Record({
	couponCode: null,
	discountAmount: null,
	isValid: null
});

class OrderStore extends ReduceStore {

	constructor() {
		super(Dispatcher);

		this.PRODUCT_ORDERS = "DESIGN_ORDERS";
		this.ORDERS_BY_STATE = "ORDERS_BY_STATE";

		this.ORDER_STAT = "ORDER_STAT";

		this.SINGLE_ORDER = "ORDER";
	}

	getInitialState() {
		return Immutable.Map();
	}

	getProductOrders(productId) {
		return this.getState().get(this.PRODUCT_ORDERS+"_"+productId) || null;
	}

	getUserOrders() {
		return this.getState().get(OrderAction.LOAD_USER_ORDERS) || null;
	}

	getOrdersByState(orderStates) {
		return this.getState().get(this.ORDERS_BY_STATE+"_"+orderStates) || null;
	}

	getOrderStat() {
		return this.getState().get(this.ORDER_STAT) || null;
	}

	getOrder(orderId) {
		return this.getState().get(this.SINGLE_ORDER+"_"+orderId) || null;
	}

	getDashainCampaignOrders() {
		return this.getState().get(OrderAction.LOAD_DASHAIN_CAMPAIGN_ORDERS) || null;
	}

	getDiscountCoupon(couponCode) {
		return this.getState().get(OrderAction.LOAD_DISCOUNT_COUPON + "_" + couponCode) || null;
	}

	getActionOrders(actionName) {
		return this.getState().get(actionName) || null;
	}

	reduce(state, action) { 

		switch (action.type) {
			case OrderAction.LOAD_PRODUCT_ORDERS:
				const productId = action.productId;

				return state.set(this.PRODUCT_ORDERS+"_"+productId, Immutable.List(action.orders));

			case OrderAction.LOAD_ALL_ORDERS_BY_STATE:
				const orderStates = action.orderStates;

				return state.set(this.ORDERS_BY_STATE+"_"+orderStates, Immutable.List(action.orders));

			case OrderAction.LOAD_USER_ORDERS:
				return state.set(OrderAction.LOAD_USER_ORDERS, Immutable.List(action.orders));

			case OrderAction.LOAD_DASHAIN_CAMPAIGN_ORDERS:
				return state.set(action.type, Immutable.List(action.orders));
			
			case OrderAction.LOAD_CHETAN_CAMPAGIN_ORDERS:
				return state.set(action.type, Immutable.List(action.orders));

			case OrderAction.UPDATE_ORDER_STATE:
				const order = action.order;
				const newState = action.newState;
				const oldState = order.orderState;

				//reset new state orders list and remove this order from current state order list
				let oldStateList = this.getOrdersByState(oldState);

				if(oldStateList)
					oldStateList = oldStateList.filter(o => o.orderId !== order.orderId);

				return state.set(this.ORDERS_BY_STATE+"_"+newState, null)
							.set(this.ORDERS_BY_STATE+"_"+oldState, oldStateList);

			case OrderAction.LOAD_ORDER_STAT:
				return state.set(this.ORDER_STAT, action.stat);

			case OrderAction.LOAD_SINGLE_ORDER:
				return state.set(this.SINGLE_ORDER+"_"+action.order.orderId, action.order);

			case OrderAction.UPDATE_SINGLE_ORDER:
				return state.clear().set(this.SINGLE_ORDER+"_"+action.order.orderId, action.order);

			case OrderAction.PLACE_ORDER:
				return state.set(OrderAction.LOAD_USER_ORDERS, null);

			case OrderAction.LOAD_DISCOUNT_COUPON:
				const discountCoupon = new DiscountCoupon({
					couponCode: action.couponCode,
					discountAmount: action.discountAmount,
					isValid: action.isValid
				});

				return state.set(OrderAction.LOAD_DISCOUNT_COUPON+"_"+action.couponCode, discountCoupon);

			case UserAction.LOGOUT:
				return state.clear();
			default:
				break;

		}
		return state;
	}
}


export default new OrderStore();


// WEBPACK FOOTER //
// ./src/stores/OrderStore.js